export const OPEN_RFP_DIALOG = "OPEN_RFP_DIALOG"
export const CLOSE_RFP_DIALOG = "CLOSE_RFP_DIALOG"
export const GET_RFP_CATALOG = "GET_RFP_CATALOG"
export const CREATE_RFP = "CREATE_RFP"
export const GET_CUSTOMER_REQUESTS = "GET_CUSTOMER_REQUESTS"
export const GET_RFPS = "GET_RFPS"
export const CREATE_QUOTATION = "CREATE_QUOTATION"
export const GET_RFP_QUOTATIONS = "GET_RFP_QUOTATIONS"
export const RFP_INC_VIEWS = "RFP_INC_VIEWS"
export const CREATE_RFP_WATCHLIST_RECORD = "CREATE_RFP_WATCHLIST_RECORD"
export const GET_RFP = "GET_RFP"
export const CREATE_GUEST_RFP = "CREATE_GUEST_RFP"
export const RFP_REQUEST = "RFP_REQUEST"
export const RFP_DIALOG_SET_EDIT_MODE = "RFP_DIALOG_SET_EDIT_MODE"
export const DUPLICATE_RFPS = "DUPLICATE_RFPS"
export const DIALOG_SET_RQUEST_ID = "DIALOG_SET_RQUEST_ID"
export const DELETE_RFP = "DELETE_RFP"
export const DELETE_RFPS = "DELETE_RFPS"
export const GET_LATEST_RFP = "GET_LATEST_RFP"
export const RFP_CHAT_AI = "RFP_CHAT_AI"
export const RFP_CHAT_AI_STATUS = "RFP_CHAT_AI_STATUS"
export const RFP_FILTER_REQUEST_TRADER = "RFP_FILTER_REQUEST_TRADER"
export const RESET_RFP_FILTER_REQUEST_TRADER = "RESET_RFP_FILTER_REQUEST_TRADER"
export const GET_MATCHING_KITS = "GET_MATCHING_KITS"
